
module.cC({

    name: 'NewProgramInitiativeController',

    inject: ['$scope', '$http', '$state', 'available', 'urlBuilder',
             'Notifications', 'initiatives', 'momentConvertFilter'],

    data: {
        'types': 'available.types',
        'grantYears': 'available.grant_years',
        'data': '{}',
    },
    methods: {
        setGrantYearDates: function(item) {
            this.data.start_date = item.start_date;
            this.data.end_date = item.end_date;
        },

        save: function(form, data) {
            if (form.$invalid) {
                this.Notifications.canned('form_errors');
                return;
            }

            data = angular.copy(data);
            if (data.name === 'amc') {
                data.grant_year = data.grant_year.year;
            } else {
                delete data.grant_year;
            }

            return this.$http.post(this.urlBuilder(), data).then(
                this._saveSuccess, this._saveError);
        },

        _saveSuccess: function(response) {
            var id, i, found;
            this.Notifications.success("New initiative created.")
            response.data = this.momentConvertFilter(response.data.item);

            for (id in response.data) {
                found = false;
                for (i = 0; i < this.initiatives.length; i++) {
                    if (this.initiatives[i].id === id) {
                        angular.copy(response.data[id], this.initiatives[i]);
                        found = true;
                    }
                }
                if (!found) {
                    this.initiatives.push(response.data[id]);
                }
            }

            this.$state.go('^');
        },

        _saveError: function() {
            this.Notifications.error('An error occurred when saving.')
        },
    },
});
